import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from './authService';

export const vendorBrandingKeys = {
  all: ['vendor-branding'],
  settings: () => [...vendorBrandingKeys.all, 'settings'],
};

const vendorBrandingApi = {
  getBranding: async () => {
    const response = await api.get('/vendor/branding');
    return response.data;
  },

  updateBranding: async (data) => {
    const response = await api.put('/vendor/branding', data);
    return response.data;
  },
};

export const useVendorBranding = (options = {}) => {
  return useQuery({
    queryKey: vendorBrandingKeys.settings(),
    queryFn: vendorBrandingApi.getBranding,
    ...options,
  });
};

export const useUpdateVendorBranding = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: vendorBrandingApi.updateBranding,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: vendorBrandingKeys.settings() });
    },
    ...options,
  });
};

export default vendorBrandingApi;
